import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjIncrementEmbedRoute: InvariantJiraRoute = {
	name: 'software-plan-increment-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed',
};
